import styled, { css } from 'react-emotion'
import { color, spacer, typography, withTheme } from 'stylist'
import { compose, withProps } from 'recompose'
import { NavLink } from 'react-router-dom'

const activeClassName = theme => css`
  && {
    border-bottom-color: ${color('lightBrandGreen', { theme })};
    color: ${color('ink', { theme })};
  }
`

const Item = compose(
  withTheme,
  withProps(({ theme, ...props }) => ({
    activeClassName: activeClassName(theme),
    ...props
  }))
)(styled(NavLink)`
  ${typography('subheading2')};
  transition: all 0.15s linear;
  padding-top: ${spacer(3)};
  padding-bottom: ${spacer(3)};
  border-bottom: 3px solid transparent;
  color: ${color('pewter')};

  &:hover {
    color: ${color('ink')};
  }

  & + & {
    margin-left: ${spacer(5)};
  }
`)

Item.displayName = 'NavTabs.Item'

export default Item



// WEBPACK FOOTER //
// ./src/components/NavTabs/Item.js